import { atom } from "jotai";

interface AuthState {
  isAuthenticated: boolean | null;
  isLoading: boolean;
  error: Error | null;
}

export const authAtom = atom<AuthState>({
  isAuthenticated: null,
  isLoading: true,
  error: null,
});

export const isAuthenticatedAtom = atom(get => get(authAtom).isAuthenticated);
export const isLoadingAtom = atom(get => get(authAtom).isLoading);
export const errorAtom = atom(get => get(authAtom).error);
